import { HELP_MAIL } from '~/constants';

export const useGetHelpEmailHook = () => {
  return HELP_MAIL;
};
